// Pagina prodotto: scelta del pacchetto, galleria, domanda di prova, barra fissa, animazioni.
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* scelta pacchetto */
  const names = { ebook: 'eBook', coach: "eBook + L&D Coach App" };
  const notes = {
    ebook: 'Instant download. Yours to keep, with a free yearly update.',
    coach: 'Instant access to the Coach, on any device.',
  };
  function pick(v) {
    const r = $(`input[name=plan][value=${v}]`); if (!r) return;
    r.checked = true; sync();
  }
  function sync() {
    const r = $('input[name=plan]:checked');
    $('#ctaTxt').textContent = r.dataset.cta;
    $('#ctaPrice').textContent = '$' + r.dataset.price;
    $('#buyNote').textContent = notes[r.value];
    $('#stName').textContent = names[r.value];
    $('#stPrice').textContent = '$' + r.dataset.price + (r.value === 'coach' ? ' · instant access' : ' · instant download');
  }
  $$('input[name=plan]').forEach((r) => r.addEventListener('change', sync));
  $$('[data-pick]').forEach((a) => a.addEventListener('click', () => pick(a.dataset.pick)));
  $('#cta').addEventListener('click', (e) => {
    e.preventDefault();
    const r = $('input[name=plan]:checked'), f = document.getElementById('dp-atc');
    if (!f) return;
    if (r.dataset.vid) f.querySelector('[name=id]').value = r.dataset.vid;
    $('#cta').disabled = true;
    f.submit();
  });
  sync();

  /* galleria: libro o schermata della piattaforma */
  const stage = $('.hero-stage'), book = $('.hero-book'), phoneImg = $('.hero-phone img');
  const phoneDefault = phoneImg.getAttribute('src');
  $$('.thumbs button').forEach((b) => b.addEventListener('click', () => {
    $$('.thumbs button').forEach((x) => x.classList.toggle('on', x === b));
    if (b.dataset.phone) { stage.classList.add('is-phone'); phoneImg.src = b.dataset.src; }
    else { stage.classList.remove('is-phone'); book.src = b.dataset.src; phoneImg.src = phoneDefault; }
  }));

  /* domanda di prova */
  const Q = {
    answer: 1,
    expl: "These are <b>recurrent late decelerations</b> (gradual, lowest point after the peak of the contraction, with at least half of the contractions) with <b>minimal</b> variability. Category III requires <b>absent</b> variability plus recurrent late or recurrent variable decelerations or bradycardia, so this tracing is <b>Category II</b>, and it still needs action now. Hypotension after the epidural is the likely cause: change the patient's position, give an IV fluid bolus, reduce or stop the oxytocin, treat the blood pressure as ordered and notify the provider, then re-evaluate the tracing. Oxygen is not routine unless the mother is hypoxic (ACOG 2025).",
    why: ["Minimal is not absent. Recurrent lates make a tracing Category III only when variability is absent, and even then intrauterine resuscitation starts right away.", "", "Recurrent lates with minimal variability call for intrauterine resuscitation now. Waiting for absent variability means waiting for the tracing to get worse."],
  };
  $$('.tq-choices button').forEach((b) => b.addEventListener('click', () => {
    const k = +b.dataset.k, ok = k === Q.answer;
    $$('.tq-choices button').forEach((x, i) => { x.disabled = true; if (i === Q.answer) x.classList.add('right'); else if (i === k) x.classList.add('wrong'); });
    const others = Q.why.map((w, i) => (w ? `<li><b>${'ABCDE'[i]}.</b> ${w}</li>` : '')).join('');
    const fb = $('#tqFb');
    fb.innerHTML = `<h4 class="${ok ? 'ok' : 'no'}">${ok ? 'Correct.' : 'Not quite. The answer is B.'}</h4><p>${Q.expl}</p>
      <ul>${others}</ul>
      <span class="tq-link">Review in the ebook: Ch. 5, Categories I, II & III</span>
      <a class="tq-cta" href="#buyStart" data-pick="coach">400 more like this in the L&D Coach →</a>`;
    fb.hidden = false;
    $('.tq-cta', fb).addEventListener('click', () => pick('coach'));
  }));

  /* barra fissa: compare quando il box d'acquisto esce dallo schermo */
  const sticky = $('#sticky'), buy = $('#buyForm'), final = $('.final');
  let buyVis = true, finalVis = false;
  const upd = () => sticky.classList.toggle('show', !buyVis && !finalVis);
  new IntersectionObserver(([e]) => { buyVis = e.isIntersecting; upd(); }).observe(buy);
  new IntersectionObserver(([e]) => { finalVis = e.isIntersecting; upd(); }).observe(final);

  /* animazioni d'ingresso */
  const els = $$('.pain, .feat, .tl, .step, .plan, .gallery figure, .tq, .devices, .g-in, .final-in');
  els.forEach((e) => e.classList.add('rv'));
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12 });
  els.forEach((e) => io.observe(e));
})();


/* galleria delle pagine vere + visore */
(() => {
  const grid = document.querySelector('.pgrid'); if (!grid) return;
  const btns = [...grid.querySelectorAll('button')], srcs = btns.map((b) => b.querySelector('img').getAttribute('src'));
  const lb = document.createElement('div'); lb.className = 'lb';
  lb.innerHTML = '<button class="x" aria-label="Close">×</button><button class="pv" aria-label="Previous">‹</button><img alt=""><button class="nx" aria-label="Next">›</button><span class="ct"></span>';
  (document.querySelector('.dmsa') || document.body).appendChild(lb);
  let i = 0; const img = lb.querySelector('img'), ct = lb.querySelector('.ct');
  const show = (k) => { i = (k + srcs.length) % srcs.length; img.src = srcs[i]; ct.textContent = (i + 1) + ' / ' + srcs.length; lb.classList.add('on'); };
  btns.forEach((b, k) => b.addEventListener('click', () => show(k)));
  lb.querySelector('.x').onclick = () => lb.classList.remove('on');
  lb.querySelector('.pv').onclick = (e) => { e.stopPropagation(); show(i - 1); };
  lb.querySelector('.nx').onclick = (e) => { e.stopPropagation(); show(i + 1); };
  lb.addEventListener('click', (e) => { if (e.target === lb) lb.classList.remove('on'); });
  document.addEventListener('keydown', (e) => { if (!lb.classList.contains('on')) return;
    if (e.key === 'Escape') lb.classList.remove('on'); if (e.key === 'ArrowRight') show(i + 1); if (e.key === 'ArrowLeft') show(i - 1); });
})();

window.addEventListener('click', (e) => {
  const a = e.target.closest && e.target.closest('a[href="#buyStart"]'); if (!a) return;
  e.preventDefault(); e.stopPropagation();
  if (a.dataset.pick) {
    const r = document.querySelector(`input[name=plan][value=${a.dataset.pick}]`);
    if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    const f = document.getElementById('dp-atc');
    if (r && r.dataset.vid && f && a.closest('.plans, .final')) {
      f.querySelector('[name=id]').value = r.dataset.vid; a.style.pointerEvents = 'none'; a.style.opacity = '.7'; f.submit(); return;
    }
  }
  const t = document.querySelector('#buyStart h1') || document.getElementById('buyStart');
  const go = () => window.scrollTo({ top: Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - 16), behavior: 'auto' });
  go(); setTimeout(go, 250); setTimeout(go, 700);
}, true);
